import React from 'react';
import { createURL } from '@sm/utils';
import Menu from './components/Menu.js';
import { plansPricingMenu } from '../../config/linkInfo';

export const PlansAndPricingMenu = () => {
  const path = createURL('/pricing/', {
    ut_source: 'megamenu',
  });

  const key = 'Plans & Pricing';

  return (
    <Menu {...plansPricingMenu()} path={path} menuKey={key}>
      <div />
    </Menu>
  );
};

export default PlansAndPricingMenu;
